import { createFileRoute } from "@tanstack/react-router"

import { TripsPage } from "@/trips/components/trips/trips-page"

export const Route = createFileRoute("/_app-shell/trips")({
  head: () => ({ meta: [{ title: "Trips - Kestly" }] }),
  component: TripsPage,
})
